function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Google__G__Logo");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Android",
  transform: "translate(-75.000000, -18.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Google__G__Logo",
  transform: "translate(75.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33,17.2750225 C33,16.135257 32.9025239,15.0532011 32.7354221,14 L17,14 L17,20.5067628 L26.0095735,20.5067628 C25.6057441,22.6420198 24.4221062,24.4454463 22.667537,25.6717764 L22.667537,30 L28.0426458,30 C31.1897302,26.9846709 33,22.541028 33,17.2750225 Z",
  id: "Path",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.9388412,34 C21.4581545,34 25.2381974,32.4428424 28,29.8043254 L22.6158798,25.4788877 C21.1094421,26.5169928 19.1984979,27.1513903 16.9388412,27.1513903 C12.5729614,27.1513903 8.87660944,24.1091658 7.55150215,20 L2,20 L2,24.4552008 C4.74785408,30.1071061 10.3969957,34 16.9388412,34 Z",
  id: "Path",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7,20.6923792 C6.66793169,19.6886617 6.49525617,18.6152416 6.49525617,17.5 C6.49525617,16.3847584 6.68121442,15.3113383 7,14.3076208 L7,10 L1.71347249,10 C0.624288425,12.2583643 0,14.795539 0,17.5 C0,20.204461 0.624288425,22.7416357 1.71347249,25 L7,20.6923792 Z",
  id: "Path",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.8670582,6.84860968 C19.324079,6.84860968 21.5173518,7.72811535 23.252536,9.4438723 L28,4.51287333 C25.126535,1.71575695 21.3646556,0 16.8670582,0 C10.3566471,0 4.73465029,3.89289392 2,9.54479918 L7.52482648,14 C8.84356647,9.89083419 12.522157,6.84860968 16.8670582,6.84860968 Z",
  id: "Path",
  fill: "#EA4335"
}))));

var SvgGoogleGLogo = function SvgGoogleGLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "34px",
    viewBox: "0 0 33 34",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleGLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Google__G__Logo.4d1c800b.svg";
export { ForwardRef as ReactComponent };